<div mat-dialog-title class="fx-layout-row fx-align--x-center">
  <h2 [innerHtml]="productCategory?.title"></h2>
  <div class="fx-flex-grow"></div>
  <button mat-icon-button color="secondary" mat-dialog-close tabindex="-1">
    <mat-icon svgIcon="x"></mat-icon>
  </button>
</div>

<mat-dialog-content>
  <mbnm-product-selector [productCategory]="productCategory" #productSelector
                         (availableProductsChanged)="availableProductsChanged($event)"
                         *ngIf="productCategory.type !== 'MAT' && productCategory.type !== 'SIZE-SELECTOR'"
                         [selectedProducts]="productCategory.selection"
                         [cols]="productCategory.cols" [mobile-cols]="productCategory.mobileCols"
                         (change)="onSelectedProductChange($event, productCategory)"
                         [noProductsAvailableMessage]="productCategory.noProductsAvailableMessage"
                         [activeGroupName]="productCategory.filteredProductsGroupName"
                         [samplesMode]="samplesMode">
  </mbnm-product-selector>
  <mbnm-mat-selector *ngIf="productCategory.type == 'MAT'"
                     [project]="project" [productCategory]="productCategory"
                     (change)="onSelectedProductChange($event, productCategory)"
                     (availableProductsChanged)="availableProductsChanged($event)"
                     [selectedProducts]="productCategory.selection"
                     [activeGroupName]="productCategory.filteredProductsGroupName"
                     [layers]="productCategory.layers"
                     [samplesMode]="samplesMode"
                     #matSelector>
  </mbnm-mat-selector>
  <mbnm-builder-size-selector *ngIf="productCategory.type == 'SIZE-SELECTOR'" [tileData]="sizeHelpInfo"
                              #sizeSelector [project]="project" [secondary]="true">
  </mbnm-builder-size-selector>
</mat-dialog-content>

<mat-dialog-actions class="fx-column-row fx-align--space-between-x fx-layout-wrap fx-gap--16px">
  <div class="fx-flex--100" *ngIf="samplesMode && productCategory.products.length > 1">
    <mat-checkbox *ngIf="samplesMode" labelPosition="before" disableRipple="true" [(ngModel)]="selectAll" (change)="toggleSelectAll()">
      Select All
    </mat-checkbox>
  </div>
  <ng-container *ngIf="productCategory.type == 'SIZE-SELECTOR' || samplesMode">
    <button mat-flat-button color="primary" [mat-dialog-close]="true" (click)="saveChanges()">
      Save
    </button>

    <button mat-flat-button mat-dialog-close color="secondary" (click)="revertChanges()">
      Cancel
    </button>
  </ng-container>

  <ng-container *ngIf="!samplesMode && showSamplesButton">
    <div></div>
    <button mat-flat-button color="secondary" (click)="showSamplesDialog()">
      Need Samples?
    </button>
  </ng-container>

  <div class="special-instructions" *ngIf="specialInstructions" [innerHtml]="specialInstructions">
  </div>

</mat-dialog-actions>

